import type { RouteRecordRaw } from 'vue-router'
import ProjectList from '@/views/middleGround/project/projectList.vue'
import ProjectDetail from '@/views/middleGround/project/projectDetail.vue'

// 地产项目
export const ProjectRoute: Array<RouteRecordRaw> = [
  {
    path: 'project/projectList',
    name: 'ProjectList',
    meta: {
      title: '地产项目-项目列表' 
    },
    component: ProjectList
  },
  {
    path: 'project/projectList/projectDetail/:id',
    name: 'ProjectDetail',
    meta: {
      title: '地产项目-项目详情' 
    },
    component: ProjectDetail
  }
]

export default ProjectRoute